
import { useStore } from '@/store'
import { defineComponent, inject, watch } from 'vue'
import { computed } from 'vue'
import { FormActionTypes } from '@/store/modules/form/action-types'
import nameSettings from '@/settings/name-settings.json'

export default defineComponent({
  name: 'NavbarProgress',
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const tabs = computed(() => [
      { name: '本体の色', done: store.getters.configBodyId },
      { name: 'へりの色', done: store.getters.configEdgeId },
      { name: '糸の色', done: store.getters.configThreadId },
      { name: 'ふたの裏', done: store.getters.configInsideId },
      { name: 'ポケット', done: store.getters.configPocketId },
      { name: 'よこ', done: store.getters.configSideId },
      { name: 'ふた', done: store.getters.configFrontId },
      { name: 'ふたの鋲', done: store.getters.configTackId },
      { name: '背中の色', done: store.getters.configBackId },
      { name: 'ネーム', done: isNameTabDone() },
      { name: 'タイプ', done: store.getters.configBagsizeId },
      { name: '完成', config: null }
    ])
    const currentTab = computed(() => store.getters.currentTab)
    const configNonameId = computed(() => store.getters.configNonameId)
    const configNamechar = computed(() => store.getters.configNamechar)
    const configNamethreadId = computed(() => store.getters.configNamethreadId)
    const configLoaded = computed(() => store.getters.configLoaded)

    // prettier-ignore
    watch(() => configLoaded.value, (_) => {
      store.dispatch(FormActionTypes.SET_CURRENT_TAB, store.getters.isAllConfigSet ? (tabs.value.length - 1) : 0)
    })

    const onClick = (index: number) => {
      store.dispatch(FormActionTypes.SET_CURRENT_TAB, index)
    }

    function isNameTabDone() {
      if (configNonameId.value == nameSettings.noName.id) {
        return true
      }
      if (configNonameId.value == nameSettings.yesName.id && hasNamechar() && configNamethreadId.value) {
        return true
      }
      return null
    }

    function hasNamechar() {
      return configNamechar.value && configNamechar.value.length > 0
    }

    return {
      tabs,
      currentTab,
      onClick
    }
  }
})
